import React, { Component } from 'react';
import PageHelmet from './Helmet';
import Breadcrumb from './Breadcrumb';
import CounterOne from './CounterOne';
import Testimonial from './Testimonial';
import BrandTwo from './BrandTwo';
import { FaFacebookF, FaLinkedinIn, FaTwitter } from 'react-icons/fa';
import ScrollToTop from 'react-scroll-up';
import { FiChevronUp } from 'react-icons/fi';
import Header from '../../../Layout/Main/header/Header';
import Footer from '../../../Layout/Main/footer/FooterTwo';

const Content = [
	{
		heading: 'Piano Moving Service',
		headingContentPara1:
			'When you are planning a move then one thing that can trouble you is your piano.  It is because pianos are heavy and bulky to move. When people try to move their pianos by themselves, they often end up damaging them. Pianos are not only expensive, but they also have sentimental values to their owners',

		subHeading: 'Why Choose Us?',
		subHeadingPara1: 'We are one of the best moving companies in British Columbia. If you are wondering what makes us different from other companies then have a look at the following points:',
		ChooseList: [
			'We love pianos and we handle them with care and diligence ',
			'The safety of your piano is our job ',
			'Our professional staff are well trained to handle Pianos without causing them any damage',
			'We pay special attention to your walls and floor to prevent any damages to the surroundings',
			'We are a trusted, Certified, and Insured company.',
		],
	},
];

class Piano extends Component {
	render() {
		let title = 'Piano',
			description =
				'There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which dont look even slightly believable. If you are going to use a passage of Lorem Ipsum Ipsum available, but the majority have suffered alteration in some form, by injected humour, or randomised words which dont look even slightly believable. If you are going.';
		return (
			<React.Fragment>
				<PageHelmet pageTitle='Piano' />

				<Header headertransparent='header--transparent' colorblack='color--black' logoname='logo.png' />
				{/* Start Breadcrump Area */}
				{/* End Breadcrump Area */}

				{/* Start About Area  */}
				<div className='rn-about-area ptb--120 bg_color--1'>
					<div className='rn-about-wrapper'>
						<div className='container'>
							<div className='row row--35 align-items-center'>
								{/* <div className="col-lg-5">
                                    <div className="thumbnail">
                                    <img className="w-100" src="/assets/images/about/about-3.jpg" alt="About Images"/>
                                    </div>
                                </div> */}
								{Content.map(content => (
									<div className='col-lg-7'>
										<div className='about-inner inner'>
											<div className='section-title'>
												<Breadcrumb title={'Piano'} />
												<h2 className='title text-left'>{content.heading}</h2>
												<p className='description'>{content.headingContentPara1}</p>
												<p>
													It is better to get help from a professional moving company. <a href='/'>Moonline</a> is always available for your service when it comes to piano moving. We have trained professionals having years of experience in moving bulky and heavy pianos. We
													possess all the tools and techniques that are required to lift and move the piano from one place to another. Whether you want to move it to another floor of the same building, or you are relocating it to another place we can make your piano moving
													safe and stress-free.
												</p>
											</div>
											<div className='row mt--30'>
												<div className='col-lg-12 col-md-12 col-sm-12 col-12'>
													<div className='about-us-list'>
														<h3 className='title'>{content.subHeading}</h3>
														<p>{content.subHeadingPara1}</p>
														<ol style={{ paddingLeft: '2vh' }}>
															{content.ChooseList.map(list => (
																<li style={{ lineHeight: 2, fontSize: '20px' }}>{list}</li>
															))}
														</ol>
														<p>
															If you are worried about pricing, then you can rest assured that we will have affordable package that suits your budget. Our pricing depends upon several factors so if you want a free estimate for your move you can always contact us through
															our website or{' '}
															<a href='/contact' style={{ fontWeight: '600' }}>
																call us
															</a>{' '}
															and One of our professional client managers will be happy to assist you with your next move.
														</p>
													</div>
												</div>
											</div>
										</div>
									</div>
								))}
							</div>
						</div>
					</div>
				</div>
				{/* End About Area  */}

				{/* Start CounterUp Area */}
				{/* <div className="rn-counterup-area pb--120 bg_color--1">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title text-center">
                                    <h3 className="fontWeight500">Our Fun Facts</h3>
                                </div>
                            </div>
                        </div>
                        <CounterOne />
                    </div>
                </div> */}
				{/* End CounterUp Area */}

				{/* Start Finding Us Area  */}
				<div className='rn-finding-us-area rn-finding-us bg_color--1'>
					{/* <div className="inner">
                        <div className="content-wrapper">
                            <div className="content">
                                <h4 className="theme-gradient">Find Your Work Now</h4>
                                <p>It is a long established fact that a reader will be distracted by the readable content of a page when looking at its layout. The point of using Lorem Ipsum is that.</p>
                                <a className="rn-btn btn-white" href="/about">Get Started</a>
                            </div>
                        </div>
                        <div className="thumbnail">
                            <div className="image">
                                <img src="/assets/images/about/finding-us-01.png" alt="Finding Images"/>
                            </div>
                        </div>
                    </div> */}
				</div>
				{/* End Finding Us Area  */}

				{/* Start Team Area  */}
				<div className='rn-team-area bg_color--1 ptb--120'>
					<div className='container'>
						{/* <div className="row">
                            <div className="col-lg-12">
                                <div className="section-title service-style--3 text-center mb--25">
                                    <h2 className="title">Skilled Team</h2>
                                    <p>There are many variations of passages of Lorem Ipsum available, but the majority have suffered alteration.</p>
                                </div>
                            </div>
                        </div> */}
						<div className='row'>
							{/* Start Single Team  */}
							{/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-01.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Jone Due</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
							{/* End Single Team  */}

							{/* Start Single Team  */}
							{/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-02.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">BM. Alamin</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
							{/* End Single Team  */}

							{/* Start Single Team  */}
							{/* <div className="col-lg-4 col-md-6 col-sm-6 col-12">
                                <div className="team">
                                    <div className="thumbnail">
                                        <img className="w-100" src="/assets/images/team/team-03.jpg" alt="Blog Images"/>
                                    </div>
                                    <div className="content">
                                        <h4 className="title">Jone Due</h4>
                                        <p className="designation">Sr. Web Developer</p>
                                    </div>
                                    <ul className="social-icon" >
                                        <li><a href="https://www.facebook.com/"><FaFacebookF /></a></li>
                                        <li><a href="http://linkedin.com/"><FaLinkedinIn /></a></li>
                                        <li><a href="https://twitter.com/"><FaTwitter /></a></li>
                                    </ul>
                                </div>
                            </div> */}
							{/* End Single Team  */}
						</div>
					</div>
				</div>
				{/* End Team Area  */}

				{/* Start Testimonial Area */}
				{/* <div className="rn-testimonial-area bg_color--5 ptb--120">
                    <div className="container">
                        <Testimonial />
                    </div>
                </div> */}
				{/* End Testimonial Area */}

				{/* Start Brand Area */}
				{/* <div className="rn-brand-area brand-separation bg_color--5 ptb--120">
                    <div className="container">
                        <div className="row">
                            <div className="col-lg-12">
                                <BrandTwo />
                            </div>
                        </div>
                    </div>
                </div> */}
				{/* End Brand Area */}

				{/* Start Back To Top */}
				<div className='backto-top'>
					<ScrollToTop showUnder={160}>
						<FiChevronUp />
					</ScrollToTop>
				</div>
				{/* End Back To Top */}

				<Footer />
			</React.Fragment>
		);
	}
}
export default Piano;
